import {
  jb_button_secondary_css_default
} from "./chunk.2KPXCSNB.js";
import {
  ae
} from "./chunk.6PQ7B7BC.js";
import {
  Linkable
} from "./chunk.3FKBYJ4V.js";
import {
  Rt
} from "./chunk.DS2KVX5X.js";
import {
  reset_css_default
} from "./chunk.PBU2AIHD.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  Initiable
} from "./chunk.6DHNIVN5.js";
import {
  ButtonElement
} from "./chunk.DIUVUHDO.js";
import {
  D,
  ke,
  r
} from "./chunk.NBIYIO67.js";
import {
  n
} from "./chunk.QXWAL3TN.js";
import {
  __decorateClass
} from "./chunk.2QRLEY22.js";

// src/components/jb-button-secondary/jb-button-secondary.ts
var JbButtonSecondary = class extends Initiable(ButtonElement(Linkable(r))) {
  render() {
    const classes = { inactive: !!this.inactive, hover: !!this.forceHover, inverted: !!this.inverted };
    return this.link?.href ? ke`<a
          data-linkable
          class=${Rt(classes)}
        >
          <slot>${this.text ? ae(this.text) : D}</slot>
        </a>` : ke`<button
          ?disabled=${this.inactive}
          class=${Rt(classes)}
        >
          <slot>${this.text ? ae(this.text) : D}</slot>
        </button>`;
  }
};
JbButtonSecondary.styles = [reset_css_default, jb_button_secondary_css_default];
JbButtonSecondary.shadowRootOptions = { ...r.shadowRootOptions, delegatesFocus: true };
__decorateClass([
  n({ type: Boolean })
], JbButtonSecondary.prototype, "forceHover", 2);
__decorateClass([
  n({ type: Boolean })
], JbButtonSecondary.prototype, "inactive", 2);
__decorateClass([
  n({ type: Boolean })
], JbButtonSecondary.prototype, "inverted", 2);
__decorateClass([
  n({ type: Object })
], JbButtonSecondary.prototype, "link", 2);
__decorateClass([
  n()
], JbButtonSecondary.prototype, "name", 2);
__decorateClass([
  n()
], JbButtonSecondary.prototype, "text", 2);
JbButtonSecondary = __decorateClass([
  customElement("jb-button-secondary")
], JbButtonSecondary);

export {
  JbButtonSecondary
};
